import { Route } from "react-router-dom";
import {
  ActionList,
  AiAssistantPage,
  AnaliticAdmin,
  AnaliticCameras,
  AnaliticMenu,
  AnaliticQueue,
  AnaliticSales,
  Anomalies,
  AnomaliesObjectDetails,
  AnomaliesType,
  Archive,
  AuthContainer,
  CallCenter,
  Camera,
  CashQueue,
  CheckTypesScreen,
  ChecksScreen,
  Courier,
  EmptyPage,
  Evotor,
  ExternalCamera,
  ExternalCameraType,
  FinOrdersCreate,
  FinOrdersList,
  FinOrdersMenu,
  Financial,
  FinancialCacheflow,
  FinancialCacheflowCommon,
  FinancialCaheflowDetails,
  FinancialLeftovers,
  FinancialPL,
  FinancialPLDetails,
  Forecast,
  GallaryList,
  GptChat,
  GptMain,
  Home,
  InfoType,
  InfoView,
  Inventory,
  InventoryCheckForm,
  InventoryCreateForm,
  InventoryListPage,
  InventoryViewCard,
  JournalActions,
  JournalDetails,
  ListSurveys,
  Loyalty,
  LoyaltyClient,
  LoyaltyClientInfo,
  LoyaltyClientReport,
  LoyaltyHistory,
  LoyaltyReport,
  Marketing,
  MonitorAll,
  Monitoring,
  MonitoringActions,
  MonitoringByCourier,
  MonitoringByRange,
  MonitoringBySource,
  MonitoringByStep,
  MonitoringByStop,
  MonitoringByStopTable,
  MonitoringCashDetails,
  MonitoringCashRegister,
  MonitoringCheckTable,
  MonitoringDetails,
  MonitoringLine,
  MonitoringLoad,
  MonitoringLosses,
  MonitoringMainData,
  MonitoringMap,
  MonitoringNonPayers,
  MonitoringSelect,
  ObjectCameras,
  OrderDetails,
  Orders,
  PdfView,
  PhoneCall,
  PhoneCallCounts,
  PhotoReport,
  PhotoReportCreate,
  PhotoReportList,
  ProductCards,
  ProductDetails,
  Products,
  Profile,
  Purchase,
  PurchaseCards,
  PurchaseDetails,
  QuestionDetails,
  QuicklyTaskCreate,
  QuicklyTaskTypes,
  Quiz,
  QuizEdit,
  QuizList,
  QuizesUser,
  RegisterContainer,
  RegisterDocDetails,
  RegisterDocs,
  Report,
  ReviewByObjects,
  ReviewCommon,
  ReviewObjList,
  ScannerPage,
  SelectAnomaliesType,
  SelectCamera,
  SelectEmployee,
  SelectLocation,
  SettingsScreen,
  StreamDetails,
  StreamPage,
  TableView,
  TaskCreate,
  TaskList,
  TaskMenu,
  TestPage,
  TimeConfirmation,
  TimeControl,
  Vacancies,
  VacanciesCreate,
  VacanciesMap,
  VideoStreams,
  ViewReport,
  Waiters,
  WaitersCards,
  WaitersCheckDetails,
  WaitersDetails,
  WorkShift,
  WorkShiftEmployee,
} from "./lazyScreens";

export { AuthContainer, RegisterContainer };

export const privateFeatureRoutes = (
  <>
    <Route path={"/"} element={<Home />} />
    <Route path={"/ai-assistant"} element={<AiAssistantPage />} />
    <Route path={"/check/:idForm"} element={<ChecksScreen />} />
    <Route path={"/check-type/:idForm"} element={<CheckTypesScreen />} />
    <Route path={"/select-location/:idForm"} element={<SelectLocation />} />
    <Route path={"/select-employee/:idForm"} element={<SelectEmployee />} />
    <Route path={"/quiz"} element={<Quiz />} />
    <Route path={"/settings"} element={<SettingsScreen />} />
    <Route path={"/camera/:answerId"} element={<Camera />} />
    <Route path={"/task-menu/:idForm"} element={<TaskMenu />} />
    <Route path={"/task-list/:idForm"} element={<TaskList />} />
    <Route path={"/task-create"} element={<TaskCreate />} />
    <Route path={"/quiz-list"} element={<QuizList />} />
    <Route path={"/quiz-author"} element={<QuizesUser />} />
    <Route path={"/quiz-details"} element={<QuestionDetails />} />
    <Route path={"/quiz-gallary"} element={<GallaryList />} />
    <Route path={"/quiz-edit"} element={<QuizEdit />} />
    <Route path={"/quickly-task-menu"} element={<QuicklyTaskTypes />} />
    <Route path={"/task-quickly-create/:id"} element={<QuicklyTaskCreate />} />
    <Route path={"/view-pdf"} element={<PdfView />} />
    <Route path={"/view-table"} element={<TableView />} />
    <Route path={"/purchase/:idForm"} element={<Purchase />} />
    <Route path={"/register-docs"} element={<RegisterDocs />} />
    <Route path={"/register-docs-details/:ID_Order/:status"} element={<RegisterDocDetails />} />
    <Route path={"/purchase-cards"} element={<PurchaseCards />} />
    <Route path={"/purchase-details"} element={<PurchaseDetails />} />
    <Route path={"/inventory/:idForm"} element={<Inventory />} />
    <Route path={"/inventory-create"} element={<InventoryCreateForm />} />
    <Route path={"/inventory-check"} element={<InventoryCheckForm />} />
    <Route path={"/inventory-view"} element={<InventoryViewCard />} />
    <Route path={"/inventory-list"} element={<InventoryListPage />} />
    <Route path={"/scanner/:idForm"} element={<ScannerPage />} />
    <Route path={"/time-control/:idForm"} element={<TimeControl />} />
    <Route path={"/time-confirmation/:idForm"} element={<TimeConfirmation />} />
    <Route path={"/time-work-shift/:idForm"} element={<WorkShift />} />
    <Route path={"/time-work-shift-employee"} element={<WorkShiftEmployee />} />
    <Route path={"/courier/:idForm"} element={<Courier />} />
    <Route path={"/courier-delivery-map"} element={<VacanciesMap />} />
    <Route path={"/vacancies"} element={<Vacancies />} />
    <Route path={"/vacancies-create"} element={<VacanciesCreate />} />
    <Route path={"/marketing/:idForm"} element={<Marketing />} />
    <Route path={"/call-center/:idForm"} element={<CallCenter />} />
    <Route path={"/products/:idForm"} element={<Products />} />
    <Route path={"/product-cards/:FTypes"} element={<ProductCards />} />
    <Route path={"/product-details"} element={<ProductDetails />} />
    <Route path={"/info-type/:idForm"} element={<InfoType />} />
    <Route path={"/info-view"} element={<InfoView />} />
    <Route path={"/report"} element={<Report />} />
    <Route path={"/report-view"} element={<ViewReport />} />
    <Route path={"/list-surveys"} element={<ListSurveys />} />
    <Route path={"/action-list"} element={<ActionList />} />
    <Route path={"/profile"} element={<Profile />} />
    <Route path={"/finOrders-menu/:idForm"} element={<FinOrdersMenu />} />
    <Route path={"/finOrders-list/:idForm"} element={<FinOrdersList />} />
    <Route path={"/finOrders-create"} element={<FinOrdersCreate />} />
    <Route path={"/photo-report"} element={<PhotoReport />} />
    <Route path={"/photo-report-list"} element={<PhotoReportList />} />
    <Route path={"/photo-report-create"} element={<PhotoReportCreate />} />
    <Route path={"/empty-page"} element={<EmptyPage />} />
    <Route path={"/test-page"} element={<TestPage />} />
    <Route path={"/call-count/:idForm"} element={<PhoneCallCounts />} />
    <Route path={"/calls"} element={<PhoneCall />} />
    <Route path={'/monitoring-all/:idForm'} element={<MonitorAll />} />
    <Route path={"/monitoring/:idForm"} element={<Monitoring />} />
    <Route path={"/monitoring-main/:idForm"} element={<MonitoringMainData />} />
    <Route path={"/monitoring-line"} element={<MonitoringLine />} />
    <Route path={"/monitoring-load/:idForm"} element={<MonitoringLoad />} />
    <Route path={"/monitoring-range/:idForm"} element={<MonitoringByRange />} />
    <Route path={"/monitoring-source/:idForm"} element={<MonitoringBySource />} />
    <Route path={"/monitoring-courier/:idForm"} element={<MonitoringByCourier />} />
    <Route path={"/monitoring-step/:idForm"} element={<MonitoringByStep />} />
    <Route path={"/monitoring-map/:idForm"} element={<MonitoringMap />} />
    <Route path={"/monitoring-select/:idForm"} element={<MonitoringSelect />} />
    <Route path={"/monitoring-stop/:idForm"} element={<MonitoringByStop />} />
    <Route path={"/monitoring-stop-table/:type"} element={<MonitoringByStopTable />} />
    <Route path={"/monitoring-non-payer/:idForm"} element={<MonitoringNonPayers />} />
    <Route path={"/monitoring-losses/:idForm"} element={<MonitoringLosses />} />
    <Route path={"/monitoring-details"} element={<MonitoringDetails />} />
    <Route path={"/monitoring-cash-register"} element={<MonitoringCashRegister />} />
    <Route path={"/monitoring-check-table"} element={<MonitoringCheckTable />} />
    <Route path={"/monitoring-cash-details"} element={<MonitoringCashDetails />} />
    <Route path={"/monitoring-actions/:idForm"} element={<MonitoringActions />} />
    <Route path={"/order-details"} element={<OrderDetails />} />
    <Route path={"/review/:idForm"} element={<ReviewCommon />} />
    <Route path={"/review-objects"} element={<ReviewByObjects />} />
    <Route path={"/review-objects-list"} element={<ReviewObjList />} />
    <Route path={"/external-camera"} element={<ExternalCamera />} />
    <Route path={"/external-camera-list/:idForm"} element={<ExternalCameraType />} />
    <Route path={"/select-camera"} element={<SelectCamera />} />
    <Route path={"/stream-page"} element={<StreamPage />} />
    <Route path={"/loyalty/:idForm"} element={<Loyalty />} />
    <Route path={"/loyalty-client"} element={<LoyaltyClient />} />
    <Route path={"/loyalty-client-info"} element={<LoyaltyClientInfo />} />
    <Route path={"/loyalty-history/:ClientID"} element={<LoyaltyHistory />} />
    <Route path={"/loyalty-report"} element={<LoyaltyReport />} />
    <Route path={"/loyalty-client-report/:FObjects"} element={<LoyaltyClientReport />} />
    <Route path={"/gpt-main/:idForm"} element={<GptMain />} />
    <Route path={"/gpt-chat"} element={<GptChat />} />
    <Route path={"/gpt-forecast"} element={<Forecast />} />
    <Route path={"/select-anomalies/:idForm"} element={<SelectAnomaliesType />} />
    <Route path={"/anomalies-type/:type"} element={<AnomaliesType />} />
    <Route path={"/detect-anomalies"} element={<Anomalies />} />
    <Route path={"/anomalies-details"} element={<AnomaliesObjectDetails />} />
    <Route path={"/financial/:idForm"} element={<Financial />} />
    <Route path={"/financial-leftovers"} element={<FinancialLeftovers />} />
    <Route path={"/financial-caheflow"} element={<FinancialCacheflow />} />
    <Route path={"/financial-caheflow-common"} element={<FinancialCacheflowCommon />} />
    <Route path={"/financial-pl"} element={<FinancialPL />} />
    <Route path={"/financial-caheflow-details"} element={<FinancialCaheflowDetails />} />
    <Route path={"/financial-pl-details"} element={<FinancialPLDetails />} />
    <Route path={"/waiters/:idForm"} element={<Waiters />} />
    <Route path={"/waiters-cards/:FTypes"} element={<WaitersCards />} />
    <Route path={"/waiters-details"} element={<WaitersDetails />} />
    <Route path={"/waiters-details-check"} element={<WaitersCheckDetails />} />
    <Route path={"/video-streams/:idForm"} element={<VideoStreams />} />
    <Route path={"/video-analitic-menu/:idForm"} element={<AnaliticMenu />} />
    <Route path={"/video-analitic/:idForm"} element={<AnaliticCameras />} />
    <Route path={"/analitic-queue/:idForm"} element={<AnaliticQueue />} />
    <Route path={"/analitic-admin/:idForm"} element={<AnaliticAdmin />} />
    <Route path={"/analitic-cash-queue/:idForm"} element={<CashQueue />} />
    <Route path={"/analitic-sales/:idForm"} element={<AnaliticSales />} />
    <Route path={"/journal-actions/:idForm"} element={<JournalActions />} />
    <Route path={"/journal-details"} element={<JournalDetails />} />
    <Route path={"/video-oblect-cameras/:idForm"} element={<ObjectCameras />} />
    <Route path={"/video-details"} element={<StreamDetails />} />
    <Route path={"/archive/:idForm"} element={<Archive />} />
    <Route path={"/evotor/:idForm"} element={<Evotor />} />
    <Route path={"/evotor-orders-org/:idForm"} element={<Orders />} />
  </>
);
